import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
// import Table1 from './Table1';

const Tab1 = ({ pageState, handleChange, onInputChange, genderList, userList, salutationList, errors, setselected_item_data, setselected_item_data_two, setselected_item_data_three, doctypeList, refetch, list_data }) => {
    const statusList = [
        { name: 'Passive' },
        { name: 'Open' },
        { name: 'Replied' },

    ];
    const account_lists = [{ name: "Current Account" },
    { name: "Old Account" },
    { name: "New Account" },
    { name: "Fixed Account" },
    ]
    return (
        <div>
            <div className="px-3 py-4" style={{ background: 'white' }}>
                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
                    <div className="col-md-12" style={{ display: 'flex' }} >
                        <div className="col-md-6 px-2">
                            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>


                                    <div style={{ flex: 1 }}>
                                        <Input
                                            id="Firstname"
                                            label="Account Name"
                                            style={{ height: "30px" }}
                                            value={pageState.firstname}
                                            onChange={(e) => handleChange('accountname', e.target.value)}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>

                                        <SelectSearch
                                            list={salutationList}
                                            label="Bank"
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            value={pageState.solution}
                                            onChange={(val) => handleChange('bank', val)}
                                            placeholder=""

                                        />
                                    </div>

                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={account_lists}
                                            label="Account Type"
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            value={pageState.gender}
                                            onChange={(val) => handleChange('accounttype', val)}
                                            placeholder=""
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={userList}
                                            label="Account Subtype"
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            value={pageState.userid}
                                            onChange={(val) => handleChange('accountsubtype', val)}
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>

                                    <div style={{ flex: 1 }}>
                                        <label style={{ height: '19px' }}></label>
                                        <Checkbox
                                            id="Sync_with_Google_Contacts"
                                            label="Disable "
                                            checked={pageState.is_google || false}
                                            onChange={(checked) => onInputChange("disable", checked)}
                                        />


                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ height: '19px' }}></label>
                                        <Checkbox
                                            id="Sync_with_Google_Contacts"
                                            label="Is Default Account"
                                            checked={pageState.is_google || false}
                                            onChange={(checked) => onInputChange("is_default", checked)}
                                        />


                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <label style={{ height: '19px' }}></label>
                                        <Checkbox
                                            id="Unsubscribed"
                                            label="Is Company Account"
                                            checked={pageState.unsubscribed || false}
                                            onChange={(checked) => onInputChange("is_company_account", checked)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 px-2">
                            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Party Details</p>
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>

                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={statusList}
                                            label="Party Type"
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            value={pageState.status}
                                            onChange={(val) => handleChange('party_type', val)}
                                            placeholder=""
                                        />
                                    </div>


                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={statusList}
                                            label="Party"
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            value={pageState.status}
                                            onChange={(val) => handleChange('party_sub_type', val)}
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Account Details</p>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>

                                    <div style={{ flex: 1 }}>
                                        <Input
                                            id="Department"
                                            label="IBAN"
                                            style={{
                                                height: "30px",
                                                ...(errors?.department ? { border: '1px solid red' } : {})
                                            }}
                                            value={pageState.department}
                                            onChange={(e) => handleChange('iban', e.target.value)}
                                        />

                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            id="Department"
                                            label="Branch Code"
                                            style={{
                                                height: "30px",
                                                ...(errors?.department ? { border: '1px solid red' } : {})
                                            }}
                                            value={pageState.department}
                                            onChange={(e) => handleChange('branchcode', e.target.value)}
                                        />

                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            id="Department"
                                            label="Bank Account No"
                                            style={{
                                                height: "30px",
                                                ...(errors?.department ? { border: '1px solid red' } : {})
                                            }}
                                            value={pageState.department}
                                            onChange={(e) => handleChange('accountno', e.target.value)}
                                        />

                                    </div>




                                </div>



                            </div>
                        </div>


                    </div>

                </div>
                <div className="mb-3" >

                    <div className="col-md-6 px-2" style={{ display: 'flex', gap: '20px' }} >
                        <div className='' style={{ backgroundColor: '#FEFAF4', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Integration Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                                                  <div style={{ flex: 1 }}>
                                        <Input
                                            id="Department"
                                            label="Last Intgration date"
                                            type="date"
                                            style={{
                                                height: "30px",
                                                ...(errors?.department ? { border: '1px solid red' } : {})
                                            }}
                                            value={pageState.department}
                                            onChange={(e) => handleChange('lastintegrationdate', e.target.value)}
                                        />

                                    </div>
                              
                            </div>
                           



                        </div>
                    </div>

                </div>


            </div>

        </div >
    );
};

export default Tab1;